import { delay } from "utils/delay";

export async function buildAndWaitForAsyncTask(
    buildFunc,
    getStatusFunc,
    getResultFunc,
    options,
    onFailedTask,
) {
    const signal = options.signal;

    const descriptor = await buildFunc();

    const taskId = descriptor.taskId;
    if (!taskId) {
        throw new Error("Task id not specified.");
    }

    do {
        if (signal && signal.aborted) {
            return null;
        }

        await delay(1000);

        if (signal && signal.aborted) {
            return null;
        }

        const status = await getStatusFunc(taskId);

        if (signal && signal.aborted) {
            return null;
        }

        switch (status.state) {
            case "Processing":
                continue;
            case "Failed":
                if (onFailedTask) {
                    return onFailedTask(descriptor);
                }
                throw new Error("Async task has failed");
            case "Completed":
                return await getResultFunc(taskId);
            default:
                throw new Error(`Unknown state: ${status.state}`);
        }
    } while (true);
}
